var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2De(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 12) scale(1.25) translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 12,
    height: 12,
    rx: 1.5,
    ry: 1.5,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 0.9,
    fill: "currentColor",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 0.8,
    fill: "currentColor",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 8.5,
    r: 1,
    fill: "currentColor",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 12,
    r: 0.8,
    fill: "currentColor",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.1,
    cy: 11.5,
    r: 1,
    fill: "currentColor",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 12.2,
    r: 0.85,
    fill: "currentColor",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.7,
    cy: 15,
    r: 0.9,
    fill: "currentColor",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.3,
    cy: 15.2,
    r: 0.8,
    fill: "currentColor",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 0.9,
    fill: "currentColor",
    opacity: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2De);
export default __webpack_public_path__ + "static/media/2DE.62f7225d409d88076c48b21201d2b078.svg";
export { ForwardRef as ReactComponent };